import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { IconButton, Box } from "@material-ui/core";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useSelector } from "react-redux";
import { userSelector } from "selectors/auth.selector";
import { PATH_NAME } from "configs";

export default function ChatIcon() {
  const [isMinimized, setIsMinimized] = useState(false);
  const [hovered, setHovered] = useState(false);

  const userinfo: any = useSelector(userSelector);
  const location = useLocation();

  const currentPath = location.pathname;

  if (!currentPath.includes("/admin")) {
    return null;
  }

  const handleCancel = (e: any) => {
    e.preventDefault();
    setIsMinimized(true);
  };

  const handleExpand = (e: any) => {
    e.preventDefault();
    setIsMinimized(false);
  };

  return (
    <>
      {!isMinimized ? (
        <a
          style={{ textDecoration: "none" }}
          href={PATH_NAME.AmtChatService}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <Box
            style={{
              position: "fixed",
              bottom: 20,
              right: 20,
              // zIndex: 9999,
            }}
          >
            <Box
              style={{
                borderRadius: "50%",
                animation: "circularPulse 2s infinite",
                padding: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >
              {hovered && (
                <IconButton
                  onClick={handleCancel}
                  style={{
                    position: "absolute",
                    top: -12,
                    right: -10,
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    zIndex: 10,
                    padding: 4,
                  }}
                  size="small"
                >
                  <CloseIcon
                    fontSize="small"
                    style={{
                      height: 15,
                      width: 15,
                    }}
                  />
                </IconButton>
              )}
              <IconButton
                style={{
                  backgroundColor: "#293FCD",
                  color: "white",
                  height: 50,
                  width: 50,
                }}
              >
                <ChatBubbleOutlineIcon style={{ height: 24, width: 24 }} />
              </IconButton>
            </Box>
          </Box>
        </a>
      ) : (
        <Box
          onClick={handleExpand}
          style={{
            position: "fixed",

            bottom: 20,
            right: 0,
            backgroundColor: "#293FCD",
            borderTopLeftRadius:15,
            borderBottomLeftRadius: 15,
            height: 45,
            width: 25,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ArrowBackIosIcon style={{ color: "#fff", fontSize: 18 }} />
        </Box>
      )}

      <style>
        {`
          @keyframes circularPulse {
            0% {
              transform: scale(1);
              box-shadow: 0 0 0 0 rgba(41, 63, 205, 0.6)
            }
            70% {
              transform: scale(1.1);
              box-shadow: 0 0 0 15px rgba(41, 63, 205, 0);
            }
            100% {
              transform: scale(1);
              box-shadow: 0 0 0 0 rgba(41, 63, 205, 0);
            }
          }
        `}
      </style>
    </>
  );
}
